import { useContext } from "react";
import { LocationContext } from "src/shared/context/location-context";
import { useIsUKUser } from "src/shared/utils/appContextHelper";
import { CarouselId } from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { TrendingEventsInLocale } from "src/website-apps/shared/components/trending-events-locale-carousel-grid";
import { DateContext } from "src/website-apps/shared/context/date-context";

/**
 * Trending Events in Locale on Home Wrapper.
 *
 * UK users must never see this carousel (compliance experiment 101280
 * TM-Global-UKRemovePopularArtistsTrendingCity, deployed variant 1).
 */
export const TrendingEventsInLocaleOnHome = ({ selectedCarouselGenre, size }) => {
  const [dates] = useContext(DateContext);
  const [userLocation] = useContext(LocationContext);
  const isUKUser = useIsUKUser();

  if (isUKUser) return null;

  return (
    <TrendingEventsInLocale
      categoryId={selectedCarouselGenre}
      dates={dates}
      userLocation={userLocation}
      size={size}
      analyticsCarouselId={CarouselId.TrendingEvents}
    />
  );
};
